/*
 *  ZAITEC CONFIDENTIAL
 *  __________________
 *
 * [2019] - [2020] zaiTEC Logixs Ltd
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of  zaiTEC Logixs Ltd and its suppliers,if any.
 *  The intellectual and technical concepts contained herein are proprietary to zaiTEC Logixs Ltd, and are protected by
 *  trade secret or copyright law.Dissemination of this information or reproduction of this material is strictly forbidden
 *  unless prior written permission is obtained from  zaiTEC Logixs Ltd.
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GoogleRedirectComponent } from './website/google-redirect/google-redirect.component';
import { NotFoundComponent } from './module-compo/admin/not-found/not-found.component';
import { AuthGuard } from './shared/guard/auth.guard';



const routes: Routes = [
    // { path: '', redirectTo: 'home' },
    { path: '', loadChildren: () => import('../app/website/website.module').then(m => m.WebsiteModule), data: {animation: 'website' }},
    { path: 'secure', loadChildren: () => import('./module-compo/layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard], data: {animation: 'dashboard'}},
    // { path: '', loadChildren: () => import('./module-compo/layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard], data: {animation: 'dashboard'}},
    { path: 'error', loadChildren: () => import('./module-compo/admin/server-error/server-error.module').then(m => m.ServerErrorModule) },
    { path: 'access-denied', loadChildren: () => import('./module-compo/admin/access-denied/access-denied.module').then(m => m.AccessDeniedModule) },
    { path: '**', redirectTo: 'not-found' },
    { path: 'not-found', component: NotFoundComponent},

    { path: 'site/oauth2/google/redirect', component: GoogleRedirectComponent },


];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        scrollOffset: [0, 64] // [x, y]
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
